import { fromByteArray } from 'base64-js';

export async function readFile(f: File): Promise<ArrayBuffer> {
    return new Promise<ArrayBuffer>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event: Event) => {
            resolve((event.target as any).result as ArrayBuffer);
        };
        reader.onerror = (ev: ProgressEvent) => {
            reject(new Error(`Cannot read file ${f.name}`));
        };

        reader.readAsArrayBuffer(f);
    });
}

export function bufferToString(fileData: ArrayBuffer): string {
    let binary = '';
    const bytes = new Uint8Array(fileData);
    const length = bytes.byteLength;
    for (let i = 0; i < length; i++) {
        binary += String.fromCharCode(bytes[i]);
    }

    return binary;
}

export interface FileUpload {
    filename: string;
    b64Content: string;
}

export async function toFileUploads(files: File[]): Promise<FileUpload[]> {
    const fuploads: FileUpload[] = [];

    for (const f of files) {
        const fileData: ArrayBuffer = await readFile(f);
        fuploads.push({
            filename: f.name,
            b64Content: fromByteArray(new Uint8Array(fileData)),
        });
    }

    return fuploads;
}
